import { Tooltip as AntdTooltip } from 'antd';
import { TooltipProps as AntdTooltipProps } from 'antd/lib/tooltip';

export type TooltipProps = AntdTooltipProps;

export const Tooltip = AntdTooltip;
export default Tooltip;
